export default __webpack_public_path__ + "static/media/speechPause.0042ef97.mp3";